"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeRegExpString = sanitizeRegExpString;
exports.splitMatchingCharacters = splitMatchingCharacters;
function sanitizeRegExpString(text) {
  var matchOperatorsRegex = /[#-.]|[[-^]|[?|{}]/g;
  return text.replace(matchOperatorsRegex, '\\$&');
}
function splitMatchingCharacters(label, search) {
  return label.split(new RegExp("(".concat(sanitizeRegExpString(search), ")"), 'gi'));
}
//# sourceMappingURL=utils.js.map